import { getFaireDirectSalesRepCode } from "@faire/marketplace-lib/utils/faireDirect";
import { usePathname } from "next/navigation";

import { useFaireDirectInfoForVisitorQuery } from "./__internal__/useFaireDirectInfoForVisitorQuery";
import { BrandTokenOrBrandAlias } from "./faireDirectTypes";

export const useFaireDirectBrandInfoForVisitor = (
  params: BrandTokenOrBrandAlias
) => {
  const pathname = usePathname();
  const salesRepCode = getFaireDirectSalesRepCode(pathname);
  const { data, isPending } = useFaireDirectInfoForVisitorQuery(
    params,
    salesRepCode
  );

  return {
    externalSalesRepName: data?.external_sales_rep_name,
    faireDirectBrandName: data?.faire_direct_brand_name,
    isPending,
  };
};
